import { Avatar, Flex, List, Typography } from "antd";
import { CertificateInterface } from "api/enumerator/Profile/dto";
import { formatDate } from "utils/date";

const { Text, Title } = Typography;

interface CertificateItemProp {
    item: CertificateInterface;
}

export const CertificateItem = ({ item }: CertificateItemProp) => (
    <List.Item>
        <List.Item.Meta
            avatar={
                <Avatar size={50} style={{ backgroundColor: "#22AD5C" }}>
                    {item?.title[0]?.toUpperCase()}
                </Avatar>
            }
            title={<Title level={5}>{item?.title}</Title>}
            description={
                <Flex vertical>
                    <Text type="secondary">
                        {item.issuedDate && formatDate(item?.issuedDate)} -{" "}
                        {item?.expiresOn && formatDate(item?.expiresOn)}
                    </Text>
                    <Flex vertical>
                        <a href={item?.fileUrl} rel="noreferrer" target="_blank"><Text type="warning">{item?.fileName}</Text></a>
                    </Flex>
                </Flex>

            }
        />
    </List.Item>
);